var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTransactions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2H4.43H22V3.62H20.38V21.19C20.38 21.4048 20.2947 21.6109 20.1428 21.7628C19.9909 21.9147 19.7848 22 19.57 22H4.43C4.21517 22 4.00915 21.9147 3.85724 21.7628C3.70534 21.6109 3.62 21.4048 3.62 21.19V3.62H2V2ZM5.24 20.38H18.76V3.62H5.24V20.38ZM10.5 13.6667C10.5 13.7833 10.62 14.5 12 14.5C13.035 14.5 13.5 13.9333 13.5 13.6667C13.5 13.4 13.5 12.8333 12 12.8333C9.39 12.8333 9 11.2667 9 10.3333C9 9.25833 9.75 8.18333 11.25 7.90833V7H12.75V7.93333C13.2507 8.04678 13.7018 8.34625 14.0289 8.78246C14.3561 9.21867 14.5399 9.76563 14.55 10.3333H13.05C13.0425 10.0333 12.975 9.5 12 9.5C11.025 9.5 10.5 10.025 10.5 10.3333C10.5 10.6417 10.5 11.1667 12 11.1667C14.61 11.1667 15 12.7333 15 13.6667C15 14.7417 14.25 15.8167 12.75 16.1V17H11.25V16.1C9.495 15.7917 9 14.4333 9 13.6667H10.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTransactions);
export default __webpack_public_path__ + "static/media/ic_transactions.a4d04dcf3555f51d5df57c7e9161a191.svg";
export { ForwardRef as ReactComponent };